import React, { useState } from 'react';
import {
    View,
    TouchableOpacity,
    Dimensions,
    Button
} from 'react-native'
import { Box, Text, Icon, Center } from 'native-base'
import QrReader from 'react-qr-reader'
import { Ionicons } from '@expo/vector-icons'

const width = Dimensions.get('window').width
const height = Dimensions.get('window').height

export default function QRScannerModal(props) {

    return (
        <Box flex={1}>
            <QrReader
                delay={300}
                onError={(e) => console.log(e)}
                onScan={(v) => props.onBarCodeScanned(v)}
                style={{ width: '100%' }}
            />
        </Box>
    )
    // return (
    //     <Camera
    //         barCodeScannerSettings={{
    //             interval: 300,
    //             barCodeTypes: [
    //                 BarCodeScanner.Constants.BarCodeType.qr,
    //                 BarCodeScanner.Constants.BarCodeType.pdf417,
    //             ],
    //         }}
    //         onBarCodeScanned={incoming => {
    //             setQr(incoming.data)
    //         }}
    //         style={{ flex: 1 }}
    //     >
    //         <Center flex={1}>
    //             <Text color={'white'} fontSize={'2xl'}>{qr}</Text>
    //         </Center>
    //     </Camera>
    // )
}